import { createFileRoute } from "@tanstack/react-router";
import { normalizeOnboardingV1StepSearch } from "~/features/start";
import { m } from "~/lib/i18n";

export const Route = createFileRoute("/start")({
  head: () => ({
    meta: [
      { title: m.start_page_meta_title() },
      { content: m.start_page_meta_description(), name: "description" },
      { content: "noindex, nofollow", name: "robots" },
    ],
  }),
  validateSearch: normalizeOnboardingV1StepSearch,
});
